module.exports = __webpack_public_path__ + "static/img/logo99.6fdb0d9.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo99.png
// module id = 6oPr
// module chunks = 1